/* File: assets/custom-microgreens-benefits.js */

(function () {
  const MQ = window.matchMedia("(max-width: 989px)");
  const isMobile = () => MQ.matches;

  function closeAll(sectionEl) {
    sectionEl.querySelectorAll('details[data-custom-mg-benefit][open]').forEach((d) => {
      d.open = false;
      const sum = d.querySelector("[data-custom-mg-summary]");
      if (sum) sum.setAttribute("aria-expanded", "false");
    });
  }

  function initSection(sectionEl) {
    const dialog = sectionEl.querySelector("[data-custom-mg-dialog]");
    const dialogInner = sectionEl.querySelector("[data-custom-mg-dialog-inner]");
    if (!dialog || !dialogInner) return;

    const detailsList = Array.from(sectionEl.querySelectorAll('details[data-custom-mg-benefit]'));
    if (!detailsList.length) return;

    // ✅ Mobile: close on click outside the card (backdrop area)
    // Some themes/iframes interfere with native backdrop click: enforce it.
    dialog.addEventListener("click", (e) => {
      // If click is NOT inside the card, we close
      const clickedInsideCard = !!e.target.closest(".custom-mg-benefit__card");
      if (!clickedInsideCard) {
        dialog.close();
      }
    });

    // Close click inside dialog (close button)
    dialog.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-custom-mg-close]");
      if (btn) {
        e.preventDefault();
        dialog.close();
      }
    });

    // Clean on close
    dialog.addEventListener("close", () => {
      dialogInner.innerHTML = "";
      closeAll(sectionEl);
    });

    detailsList.forEach((details) => {
      const summary = details.querySelector("[data-custom-mg-mobile-open]") || details.querySelector("[data-custom-mg-summary]");
      const card = details.querySelector("[data-custom-mg-card]");
      if (!summary || !card) return;

      summary.addEventListener("click", (e) => {
        if (isMobile()) {
          // prevent <details> behavior on mobile
          e.preventDefault();
          e.stopPropagation();

          closeAll(sectionEl);

          // clone card into dialog
          dialogInner.innerHTML = "";
          dialogInner.appendChild(card.cloneNode(true));

          if (typeof dialog.showModal === "function") {
            dialog.showModal();
          } else {
            // fallback: open details if dialog unsupported
            details.open = true;
            summary.setAttribute("aria-expanded", "true");
          }
          return;
        }

        // Desktop behavior: let details toggle, update aria-expanded
        queueMicrotask(() => {
          const expanded = details.open ? "true" : "false";
          summary.setAttribute("aria-expanded", expanded);

          if (details.open) {
            detailsList.forEach((d) => {
              if (d !== details && d.open) {
                d.open = false;
                const s2 = d.querySelector("[data-custom-mg-summary]");
                if (s2) s2.setAttribute("aria-expanded", "false");
              }
            });
          }
        });
      });
    });

    // Desktop: click outside closes (inside section)
    document.addEventListener("click", (e) => {
      if (isMobile()) return;
      if (!sectionEl.contains(e.target)) return;

      sectionEl.querySelectorAll('details[data-custom-mg-benefit][open]').forEach((d) => {
        const sum = d.querySelector("summary");
        const pop = d.querySelector(".custom-mg-benefit__popover");
        if (sum && sum.contains(e.target)) return;
        if (pop && pop.contains(e.target)) return;

        d.open = false;
        const s = d.querySelector("[data-custom-mg-summary]");
        if (s) s.setAttribute("aria-expanded", "false");
      });
    });

    // Desktop: close button closes
    sectionEl.addEventListener("click", (e) => {
      if (isMobile()) return;
      const btn = e.target.closest("[data-custom-mg-close]");
      if (!btn) return;
      const details = btn.closest('details[data-custom-mg-benefit]');
      if (!details) return;

      details.open = false;
      const s = details.querySelector("[data-custom-mg-summary]");
      if (s) s.setAttribute("aria-expanded", "false");
    });

    // ESC closes desktop details (dialog handles ESC natively)
    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;
      if (!isMobile()) closeAll(sectionEl);
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('section[data-custom-mg-benefits]').forEach(initSection);
  });

  document.addEventListener("shopify:section:load", (e) => {
    const sectionEl = e.target;
    if (sectionEl && sectionEl.matches && sectionEl.matches('section[data-custom-mg-benefits]')) {
      initSection(sectionEl);
    }
  });
})();
